import { Button } from "@themes/pollinator/ui/Button";
import { Type } from "@themes/pollinator/ui/Type";

export type Props = {
  currentDeviceLabel: string;
  onSwitch: () => void | Promise<void>;
  onDismiss: () => void;
};

/**
 * In-meeting toast surface for the iPhone-as-mic Continuity alert. Mirrors
 * the visual chrome applied to default sonner toasts by `themes/pollinator/
 * ui/Toast` (bg-brand-50 / border-brand-800 / shadow-lg) so a custom toast
 * (`toast.custom`) matches the rest of the in-meeting toast stack.
 *
 * Pure presentational — receives labels and callbacks. The container
 * (`useIPhoneMicToast`) wires it to the platform store, the Chime SDK, and
 * telemetry, and feeds it to `toast.custom((id) => <IPhoneMicToast ... />)`.
 */
export function IPhoneMicToast({
  currentDeviceLabel,
  onSwitch,
  onDismiss,
}: Props) {
  return (
    <div
      role="alert"
      aria-live="polite"
      className="bg-brand-50 text-brand-950 border border-brand-800 shadow-lg rounded-md px-4 py-3 flex items-start gap-3 max-w-md"
    >
      <div className="flex-1 min-w-0 flex flex-col gap-4">
        <Type variant="caption">
          Audio is being picked up from your iPhone (
          <span className="font-medium">{currentDeviceLabel}</span>).
        </Type>
        <div className="flex items-center gap-2">
          <Button variant="secondary" onClick={onDismiss}>
            Dismiss
          </Button>
          <Button onClick={onSwitch}>Don&apos;t use iphone mic</Button>
        </div>
      </div>
    </div>
  );
}
